import { extractApiErrorMessage } from '../../../Utils/apiErrorUtils';

export const getCashReportsErrorCode = (error: unknown): string | null => {
  if (!error || typeof error !== 'object' || !('data' in error)) {
    return null;
  }

  const data = (error as { data?: unknown }).data;
  if (!data || typeof data !== 'object' || !('errorCode' in data)) {
    return null;
  }

  const errorCode = (data as { errorCode?: unknown }).errorCode;
  return typeof errorCode === 'string' && errorCode.length > 0 ? errorCode : null;
};

export const toCashReportsUserMessage = (error: unknown, fallbackMessage: string): string => {
  const baseMessage = extractApiErrorMessage(error, fallbackMessage);
  const errorCode = getCashReportsErrorCode(error);
  return errorCode ? `${baseMessage} (${errorCode})` : baseMessage;
};
